<div fxFlex="100%" fxLayout="row wrap" fxLayoutAlign="flex-start flex-start" class="navbar-menu">

    <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between center"  class="title-panel-bar primary p-12">
        <ng-container [ngSwitch]="panel">
            <span *ngSwitchCase="panelNames.notificationPanel" 
                class="panel-title">{{'NOTIFICATIONS-PANEL.TITLE' | translate}}</span>
            <span *ngSwitchCase="panelNames.reportPanel" 
                class="panel-title">{{'REPORTS-PANEL.TITLE' | translate}}</span>
        </ng-container>
    
        <div fxLayout="row" fxLayoutAlign="center center">
            <button mat-icon-button
                    (click)="refreshPanelDataSubject.next()"
                    matTooltip="{{'BUTTONS.REFRESH' | translate}}"
                    aria-label="Refresh Panel Data"
                    [disabled]="isLoading">
                <mat-icon class="secondary-text">refresh</mat-icon>
            </button>

            <button mat-icon-button
                    (click)="toggleSidebarOpen(panel)"
                    matTooltip="{{'BUTTONS.CLOSE' | translate}}"
                    aria-label="Toggle panel">
                <mat-icon class="secondary-text">close</mat-icon>
            </button>
        </div>
    </div>

    <div fxFlex="100%" fxLayout="column" class="navbar-menu">

        <ng-container [ngSwitch]="panel">
            <notifications-panel
                fxLayout="column"
                *ngSwitchCase="panelNames.notificationPanel"
                [refreshPanelDataObservable]="refreshPanelDataSubject.asObservable()"
                (loading)="isLoading = $event">
            </notifications-panel>
            <reports-panel 
                fxLayout="column" 
                *ngSwitchCase="panelNames.reportPanel"
                [refreshPanelDataObservable]="refreshPanelDataSubject.asObservable()"
                (loading)="isLoading = $event">
            </reports-panel>
        </ng-container>
    
    </div>
</div>
